import { allowancePolicy } from 'modules/timeoff/store/collections/timeoffPolicies/policies'
import type Allowance from 'modules/timeoff/store/models/Allowance'
import type LeaveType from 'modules/timeoff/store/models/LeaveType'

function VisibleLeaveTypes(allowance: Allowance, types: LeaveType[]) {
  const timeoffPolicy = allowancePolicy(allowance)

  const otherAllowancesFromPolicy = timeoffPolicy?.allowances.filter(
    (a) => a.attributes.id !== allowance.attributes.id
  )

  const usedLeaveTypeIds = otherAllowancesFromPolicy?.flatMap((a) => a.attributes.leave_type_ids)

  const visibleLeaveTypes: LeaveType[] = types.filter(
    (leaveType: LeaveType) =>
      allowance.attributes.leave_type_ids.includes(leaveType.attributes.id) ||
      !usedLeaveTypeIds?.includes(leaveType.attributes.id)
  )

  return visibleLeaveTypes
}

export default VisibleLeaveTypes
